import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metrics-form',
  templateUrl: './metrics-form.component.html',
  styleUrls: ['./metrics-form.component.css']
})
export class MetricsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/work-order/metrics/metrics-form/metrics-form.component.ts